<div class="app-container">
  <app-nav-bar [pageRoute]="currentUrl" *ngIf='!isFullPage'></app-nav-bar>

  <div class="app-body" [class.app-body-login]="isFullPage" (click)="closeTopMenu()">

    <button *ngIf="currentUrl !== '/login' && isFullPage" class="fixed bottom-2 left-2 w-8 hover:opacity-60 opacity-40"
      (click)="goHome()">
      <img src="../../../../../../assets/image/Icons/home.png" alt="home" loading="lazy">
    </button>

    <router-outlet></router-outlet>
  </div>
  <app-loading *ngIf="loading"></app-loading>
</div>

<!-- Email Migration Notification Overlay -->
<div *ngIf="false"
  class="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-slate-950/70 backdrop-blur-md transition-opacity duration-300">
  <div
    class="relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden border border-slate-100 flex flex-col transform transition-all duration-300">

    <!-- Header Section -->
    <div class="px-6 pt-6 pb-4 flex justify-between items-start border-b border-slate-100 bg-slate-50/50">
      <div class="flex items-center space-x-3">
        <!-- Modern Info / Mail Icon -->
        <div class="p-2.5 bg-blue-50 text-blue-600 rounded-xl flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 animate-pulse" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 19v-8.93a2 2 0 01.89-1.664l8-5.333a2 2 0 012.22 0l8 5.333A2 2 0 0121 10.07V19M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0l-2.25-1.5a2 2 0 00-2.22 0l-2.25 1.5" />
          </svg>
        </div>
        <div>
          <h2 class="text-lg font-bold text-slate-800 tracking-tight">
            {{ currentNoticeLanguage === 'en' ? 'Email Service Has Moved' : 'විද්‍යුත් තැපැල් සේවාව වෙනස් වී ඇත' }}
          </h2>
          <p class="text-xs text-slate-500 font-medium">
            {{ currentNoticeLanguage === 'en' ? 'System Migration Alert' : 'පද්ධති සංක්‍රමණ දැනුම්දීම' }}
          </p>
        </div>
      </div>

      <!-- Language Selector & Close Button -->
      <div class="flex items-center space-x-3">
        <!-- Bilingual Tabs/Toggle -->
        <div class="flex bg-slate-100 p-0.5 rounded-lg border border-slate-200">
          <button (click)="selectNoticeLanguage('en')"
            [class]="currentNoticeLanguage === 'en' 
                           ? 'px-3 py-1 text-xs font-bold bg-white text-blue-600 rounded-md shadow-sm transition-all' 
                           : 'px-3 py-1 text-xs font-semibold text-slate-600 hover:text-slate-900 rounded-md transition-all'">
            English
          </button>
          <button (click)="selectNoticeLanguage('si')"
            [class]="currentNoticeLanguage === 'si' 
                           ? 'px-3 py-1 text-xs font-bold bg-white text-blue-600 rounded-md shadow-sm transition-all' 
                           : 'px-3 py-1 text-xs font-semibold text-slate-600 hover:text-slate-900 rounded-md transition-all'">
            සිංහල
          </button>
        </div>

        <!-- Standard Close Button -->
        <button (click)="dismissEmailNotice()"
          class="p-1.5 rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Content Body Section -->
    <div class="p-6 overflow-y-auto max-h-[60vh] space-y-4 text-slate-700 text-sm md:text-base leading-relaxed">
      <!-- English Content -->
      <div *ngIf="currentNoticeLanguage === 'en'" class="space-y-4">
        <div class="p-4 bg-amber-50 border-l-4 border-amber-500 rounded-r-xl">
          <p class="font-semibold text-amber-900 text-sm md:text-base">Google Workspace email has been discontinued.</p>
          <p class="text-amber-800 text-xs md:text-sm mt-1">Please transition to Microsoft 365 Outlook to access your
            email accounts.</p>
        </div>

        <div class="space-y-2">
          <h3 class="font-bold text-slate-800 text-sm md:text-base">How to access your email:</h3>
          <div class="p-4 bg-slate-50 rounded-xl border border-slate-100 space-y-3">
            <div class="flex items-start space-x-3">
              <span
                class="flex h-5 w-5 items-center justify-center rounded-full bg-blue-100 text-blue-600 text-xs font-bold mt-0.5">1</span>
              <div>
                <p class="font-semibold text-slate-800 text-xs md:text-sm">Use Microsoft 365 Outlook</p>
                <p class="text-slate-500 text-xs">Access all your emails, calendar, and contacts on the new platform.
                </p>
              </div>
            </div>

            <div class="flex items-start space-x-3">
              <span
                class="flex h-5 w-5 items-center justify-center rounded-full bg-blue-100 text-blue-600 text-xs font-bold mt-0.5">2</span>
              <div class="w-full">
                <p class="font-semibold text-slate-800 text-xs md:text-sm">Outlook Web Login</p>
                <a href="https://outlook.office.com" target="_blank"
                  class="inline-flex items-center space-x-1.5 font-bold text-blue-600 hover:text-blue-800 hover:underline mt-1 bg-white px-3 py-1.5 rounded-lg border border-slate-200 shadow-sm text-xs md:text-sm transition-all">
                  <span>Go to outlook.office.com</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          class="flex items-start space-x-2.5 text-xs md:text-sm text-slate-600 bg-blue-50/50 p-3.5 rounded-xl border border-blue-100/50">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-500 shrink-0 mt-0.5" fill="none"
            viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p>
            If you do not have your login credentials or experience any issues accessing your account or migrated data,
            please contact the <strong class="text-slate-800 font-semibold">IT Team</strong>.
          </p>
        </div>
      </div>

      <!-- Sinhala Content -->
      <div *ngIf="currentNoticeLanguage === 'si'" class="space-y-4">
        <div class="p-4 bg-amber-50 border-l-4 border-amber-500 rounded-r-xl">
          <p class="font-semibold text-amber-900 text-sm md:text-base leading-relaxed">Google Workspace විද්‍යුත් තැපැල්
            සේවාව (Email) අත්හිටුවා ඇත.</p>
          <p class="text-amber-800 text-xs md:text-sm mt-1 leading-relaxed">කරුණාකර ඔබගේ විද්‍යුත් තැපෑල සඳහා මින්
            ඉදිරියට Microsoft 365 Outlook භාවිතා කරන්න.</p>
        </div>

        <div class="space-y-2">
          <h3 class="font-bold text-slate-800 text-sm md:text-base">ඔබගේ විද්‍යුත් තැපෑලට පිවිසීමට:</h3>
          <div class="p-4 bg-slate-50 rounded-xl border border-slate-100 space-y-3">
            <div class="flex items-start space-x-3">
              <span
                class="flex h-5 w-5 items-center justify-center rounded-full bg-blue-100 text-blue-600 text-xs font-bold mt-0.5">1</span>
              <div>
                <p class="font-semibold text-slate-800 text-xs md:text-sm">Microsoft 365 Outlook භාවිතා කරන්න</p>
                <p class="text-slate-500 text-xs leading-relaxed">නව පද්ධතිය හරහා ඔබගේ විද්‍යුත් තැපෑල (Email), දින
                  දර්ශනය (Calendar) සහ සබඳතා (Contacts) වෙත පිවිසෙන්න.</p>
              </div>
            </div>

            <div class="flex items-start space-x-3">
              <span
                class="flex h-5 w-5 items-center justify-center rounded-full bg-blue-100 text-blue-600 text-xs font-bold mt-0.5">2</span>
              <div class="w-full">
                <p class="font-semibold text-slate-800 text-xs md:text-sm">Outlook වෙබ් පිවිසුම (Login)</p>
                <a href="https://outlook.office.com" target="_blank"
                  class="inline-flex items-center space-x-1.5 font-bold text-blue-600 hover:text-blue-800 hover:underline mt-1 bg-white px-3 py-1.5 rounded-lg border border-slate-200 shadow-sm text-xs md:text-sm transition-all">
                  <span>outlook.office.com වෙත පිවිසෙන්න</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          class="flex items-start space-x-2.5 text-xs md:text-sm text-slate-600 bg-blue-50/50 p-3.5 rounded-xl border border-blue-100/50">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-500 shrink-0 mt-0.5" fill="none"
            viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p class="leading-relaxed">
            ඔබට ඇතුල් වීමේ තොරතුරු (Login credentials) නොලැබුනේ නම්, හෝ ඔබගේ ගිණුමට හෝ මාරු කරන ලද දත්ත වලට ප්‍රවේශ
            වීමේදී කිසියම් ගැටලුවක් ඇත්නම්, කරුණාකර <strong class="text-slate-800 font-semibold">තොරතුරු තාක්ෂණ සහාය
              කණ්ඩායම (IT Team)</strong> අමතන්න.
          </p>
        </div>
      </div>
    </div>

    <!-- Bottom Footer Section -->
    <div class="px-6 py-4 bg-slate-50 border-t border-slate-100 flex items-center justify-end">
      <!-- Got It Action Button -->
      <button (click)="dismissEmailNotice()"
        class="px-5 py-2 text-xs md:text-sm font-bold bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white rounded-xl shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all flex items-center space-x-1">
        <span>{{ currentNoticeLanguage === 'en' ? 'Got It' : 'තේරුම් ගත්තා' }}</span>
      </button>
    </div>
  </div>
</div>